module.exports = __webpack_public_path__ + "img/icon_tj_no.6c839fa0.png";